export default __webpack_public_path__ + "static/media/trip-details.9b4029bf.svg";